// Third Party Libraries Imports
import toast from "react-hot-toast";
// import { AxiosResponse } from "axios";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

// Local Imports
import instance from "../../store/axios";
import { LOADING } from "../../store/actions";
import { AxiosResponse } from "axios";

class EditPortfolioService {
  private navigate = useNavigate();
  private dispatch = useDispatch();

  public async getCountriesData(
    portfolioId: string | undefined
  ): Promise<any[] | undefined> {
    this.dispatch({ type: LOADING, payload: true });

    try {
      const response: AxiosResponse<any> = await instance.get(
        `/${process.env.REACT_APP_ENDPOINT_VERSION}/option/countries?partial=${1}`
      );
      return response.data.data;
    } catch (error: any) {
      if (error?.response?.status !== 401) {
        toast.error(error?.response?.data?.message || "An error occurred");
      }
      localStorage.setItem(
        "star_prev_url",
        `/portfolio/edit-portfolio/${portfolioId}`
      );

      return undefined;
    } finally {
      this.dispatch({ type: LOADING, payload: false });
    }
  }

  public async getPortfolioDetails(
    portfolioId: string | undefined
  ): Promise<any | undefined> {
    this.dispatch({ type: LOADING, payload: true });

    try {
      const response: AxiosResponse<any> = await instance.get(
        `/${process.env.REACT_APP_ENDPOINT_VERSION}/portfolio-type/${portfolioId}`
      );
      return response.data.data;
    } catch (error: any) {
      if (error?.response?.status !== 401) {
        toast.error(error?.response?.data?.message || "An error occurred");
      }
      localStorage.setItem(
        "star_prev_url",
        `/portfolio/edit-portfolio/${portfolioId}`
      );
      return undefined;
    } finally {
      this.dispatch({ type: LOADING, payload: false });
    }
  }

  public async submitForm(
    values: any,
    portfolioId: string | undefined
  ): Promise<void> {
    this.dispatch({ type: LOADING, payload: true });

    const formData = new FormData();
    formData.append("nameEn", values.nameEn);
    formData.append("nameAr", values.nameAr);
    formData.append("minimumAmount", values.minimumAmount);
    formData.append("currencyId", values.currencyId);
    formData.append("descriptionEn", values.descriptionEn);
    formData.append("descriptionAr", values.descriptionAr);
    formData.append("termsAndConditionsEn", values.termsAndConditionsEn);
    formData.append("termsAndConditionsAr", values.termsAndConditionsAr);
    formData.append("newAgreementTerms", values.newAgreementTerms);
    formData.append("newAgreementTermsAr", values.newAgreementTermsAr);
    if (values.formFile.file) {
      formData.append("formFile", values.formFile.file);
    }
    if (values.agreementFileAr.file) {
      formData.append("agreementFileAr", values.agreementFileAr.file);
    }
    if (values.agreementFileEn.file) {
      formData.append("agreementFileEn", values.agreementFileEn.file);
    }
    if (values.newAgreementFile.file) {
      formData.append("newAgreementFile", values.newAgreementFile.file);
    }

    values.strategies?.forEach((item: any, index: number) => {
      formData.append(`strategies[${index}][strategyId]`, item.id);
      formData.append(`strategies[${index}][nameEn]`, item.nameEn);
      formData.append(`strategies[${index}][nameAr]`, item.nameAr);
      formData.append(`strategies[${index}][isActive]`, "1");
      formData.append(
        `strategies[${index}][descriptionEn]`,
        item.descriptionEn
      );
      formData.append(
        `strategies[${index}][descriptionAr]`,
        item.descriptionAr
      );
    });

    try {
      await instance.post(`/${process.env.REACT_APP_ENDPOINT_VERSION}/portfolio-type/${portfolioId}`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      toast.success("Portfolio type updated  successfully");
      this.navigate("/portfolio/types");
    } catch (error: any) {
      if (error?.response?.status !== 401) {
        toast.error(error?.response?.data?.message || "An error occurred");
      }
      localStorage.setItem(
        "star_prev_url",
        `/portfolio/edit-portfolio/${portfolioId}`
      );
    }
    this.dispatch({ type: LOADING, payload: false });
  }
}

export default EditPortfolioService;
